import { GlobalOutlined } from "@ant-design/icons";
import { Dropdown, Space, Typography } from "antd";
import { getLocale } from "@airange/shared/i18n-micro-lab-admin";
import { useIntl } from "@umijs/max";
import { microLabAdminLocaleController } from "../lib/locale";

const localeItems = [
  { key: "zh-CN", labelMessageId: "microLab.locale.zhCN" },
  { key: "en", labelMessageId: "microLab.locale.en" },
  { key: "ja", labelMessageId: "microLab.locale.ja" },
];

export function LocaleSwitch() {
  const intl = useIntl();
  const currentLocale = getLocale();
  const currentLabel =
    localeItems.find((item) => item.key === currentLocale)?.labelMessageId ?? "microLab.locale.zhCN";
  return (
    <Dropdown
      menu={{
        items: localeItems.map((item) => ({
          key: item.key,
          label: intl.formatMessage({ id: item.labelMessageId }),
        })),
        onClick: ({ key }) => {
          microLabAdminLocaleController.switchLocale(String(key));
        },
        selectable: true,
        selectedKeys: [currentLocale],
      }}
      trigger={["click"]}
    >
      <Typography.Link>
        <Space size={6}>
          <GlobalOutlined />
          <span>{intl.formatMessage({ id: currentLabel })}</span>
        </Space>
      </Typography.Link>
    </Dropdown>
  );
}
